exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".framed-table[data-v-0c45224f]{border:1px solid #d5d7da;border-radius:6px;overflow:hidden;background:#fff}.framed-table__scroll[data-v-0c45224f]{overflow-x:auto}.framed-table__table[data-v-0c45224f]{margin:0;font-size:13px}.framed-table__table>thead>tr>th[data-v-0c45224f]{border-bottom:1px solid #d5d7da}.framed-table__footer[data-v-0c45224f]{border-top:1px solid #d5d7da}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c45224f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/default/framedTable.vue
// module id = 887
// module chunks = 0